module.exports = __webpack_public_path__ + "5ba3e9d1abe780835b615fdc538407e9.svg";